import React from "react";
import { trackClickEvent } from "../utils/analytics";
import { Link } from "react-router-dom";
import logored from "../assets/images/logored.svg";
import GallerySlider from "./GallerySlider";

export default function HomeMedia() {
  return (
    <section className="relative bg-black text-white py-16 px-0">
      {/* Top Info Banner with brand margins */}
      <div className="w-full pl-6 md:pl-8 pt-10 pb-10 mb-0">
        <h2 className="text-3xl md:text-5xl font-semibold leading-[1.1] mb-2">
          STROBE AVIATION IS
        </h2>
        <p className="text-2xl md:text-3xl font-light leading-[1.1] mb-2 tracking-tight">
          Aviation marketing and movement; down to a science.
        </p>
        <p className="text-2xl md:text-3xl font-light leading-[1.1] mb-4 tracking-tight">
          Built by a 10,000-hour pilot who knows what sells and what flies.
        </p>
        <div className="flex items-center gap-2 text-strobe-gray font-semibold text-base sm:text-lg">
          <img src={logored} alt="Strobe Logo" className="w-6 h-6" />
          Crafted in flight – trusted by the pros
        </div>
      </div>

      {/* GallerySlider respecting same left-side margin */}
      <div className="w-full px-6 md:px-8 mt-8">
        <GallerySlider />
      </div>
    </section>
  );
}

    
